import angular from 'angular';
import { LoadParams } from '../../../shared/models/loadparams.model';
import { IPromocao } from './models/promocao.model';

export class MeurhSolicitacoespromocoesService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public loading_deferred_filter: any = null;
    public entity: IPromocao;
    public entities: Array<IPromocao> = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = '';
    public filters: any = {};
    public loadParams: LoadParams;
    public loading_deferred: any = null;
    public filter: string = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IScope,
        public $q: angular.IQService
    ) {
        this.loadParams = new LoadParams();
    }

    reload(): Array<IPromocao> {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter: any): Array<IPromocao> {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;

            Object.keys(this.filters).forEach((k: any): void => {
                delete this.filters[k];
            });

            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_solicitacoespromocoes_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
            .then((response: any): void => {
                resolve(response.data);
            })
            .catch((response: any): void => {
                reject(response);
            });
        });
    }

    load(): Array<IPromocao> {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any): void => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }

                        this.after['created_at'] = this.entities[this.entities.length - 1]['data'];
                        this.after['solicitacao'] = this.entities[this.entities.length - 1]['solicitacao'];
                    }

                    if (data.length < 20) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_solicitacoespromocoes_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;

                    if (this.loadParams.to_load === 0 || data.length <= 20) {
                        this.$rootScope.$broadcast('meurh_solicitacoespromocoes_loaded', this.entities);
                    }
                })
                .catch((error): void => {
                    console.log(error);
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally((): void => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }

                    this.load();
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 3;
        this.load();
    }

    get(id: string) {
        this.loading_deferred = this.$q.defer();
        this.loadParams.busy = true;
        return this.$q<IPromocao>((resolve, reject) => {
            this.$http.get<IPromocao>(
                this.nsjRouting.generate('meurh_solicitacoespromocoes_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoespromocoes_getloaded', response.data);
                this.loadParams.busy = false;
                resolve(response.data);
            })
            .catch((response) => {
                this.loadParams.busy = false;
                reject(response);
            });
        });
    }

    _save(entity: IPromocao,
        params: { empresa: string, estabelecimento: string },
        autosave: boolean): angular.IHttpPromise<any> {
        let method: string, url: string;

        if (entity['solicitacao']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_solicitacoespromocoes_put', {
                'id': entity['solicitacao'],
                'grupoempresarial': entity.constructors.grupoempresarial,
                'tenant': entity.constructors.tenant,
                ...params
            }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_solicitacoespromocoes_create', {
                'grupoempresarial': entity.constructors.grupoempresarial,
                'tenant': entity.constructors.tenant,
                ...params
            }, true);
        }

        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }

        let data = angular.copy(entity);

        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }

        this.loading_deferred = this.$q.defer();

        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        })
        .finally((): void => {
            if (!autosave) {
                entity['$$__submitting'] = false;
            }
        });
    }

    save(entity: IPromocao,
        params: { empresa: string, estabelecimento: string },
        autosave: boolean = false): void {
        this._save(entity, params, autosave)
            .then((response: any): void => {
                if (response.data.solicitacao) {
                    entity['solicitacao'] = response.data.solicitacao;
                }

                entity['$$_saved'] = true;

                this.$rootScope.$broadcast('meurh_solicitacoespromocoes_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response): void => {
                this.$rootScope.$broadcast('meurh_solicitacoespromocoes_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    delete($identifier: any, force: boolean = false): void {
        if (typeof ($identifier) === 'object') {
            $identifier = $identifier['solicitacao'];
        }

        if ($identifier) {
            if (force) {
                this.loading_deferred = this.$q.defer();

                this.$http.delete(
                    this.nsjRouting.generate('meurh_solicitacoespromocoes_delete', angular.extend(this.constructors, { 'id': $identifier }), true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_solicitacoespromocoes_deleted', {
                        entity: this.entity,
                        response: response
                    });
                })
                .catch((response) => {
                    this.$rootScope.$broadcast('meurh_solicitacoespromocoes_delete_error', {
                        entity: this.entity,
                        response: response
                    });
                });
            }
        }
    }
}
